import { ReactElement } from 'react';
import '../styles/global.scss';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
// import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

function Home(): ReactElement {
  return (
    <div className="home">
      <Navbar />
      <Hero />
      <Services />
      {/* <About /> */}
      <Contact />
      <Footer />
    </div>
  );
}

export default Home;
